import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import {withSnackbar} from "notistack";
import LinearProgress from "@material-ui/core/LinearProgress";
import {withStyles} from "@material-ui/core/styles";
import {getErrorMessageFromResponse} from "../../common/helper";

const styles = theme => ({
    progressMessage: {
        color: '#808080',
        fontSize: '0.75rem',
        fontWeight: '500',
        lineHeight: '24px',
        paddingLeft: theme.spacing(1)
    },
    progressBar: {
        marginTop: -theme.spacing(1)
    },
})

class CompareCustomDialog extends React.Component {
    state = {
        open: false,
        url: ""
    };

    UNSAFE_componentWillMount() {
        this.compare();
    }

    componentDidMount(){
        this.setState({ open: true })
    }


    handleCloseDialog = () => {
        this.setState({ open: false });
        this.props.handleCloseDialog()
    };

    compare = async () => {

        this.setState({ isFetching: true})

        const url = window.REACT_APP_CONTENT_API_BASE_URL + '/api/box/document/comparepublished';
        let body = this.props.actionConfig.body;
        body.sourceId = this.props.id;
        body.from = "enterprise_" + window.REACT_APP_ENTERPRISE_ID + "." + this.props.actionConfig.templateKey;

        const request = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.props.userDetails.accessToken
            },
            body: JSON.stringify(body)
        };

        window.location.pathname.toLowerCase().includes("debug") && console.log ((new Date()).toLocaleTimeString() + " compare url :", url, "body=", body);

        await this.props.triggerRefreshAuthToken();
        let error = false;
        fetch(url , request )
            .then(response => {
                window.location.pathname.toLowerCase().includes("debug") && console.log ((new Date()).toLocaleTimeString() + " compare response = ", response);
                if (response.ok) {
                    return(response.text())
                } else {
                    error = true;
                    Promise.resolve(getErrorMessageFromResponse(response, 'retrieving metadata'))
                        .then(message => {
                            this.props.enqueueSnackbar(message , {variant: 'error'});
                        })
                    window.location.pathname.toLowerCase().includes("debug") && console.log("compare error.  url:", url, "request: ", request, "response.text:", response);
                    this.handleCloseDialog();
                }
            })
            .then(result => {
                window.location.pathname.toLowerCase().includes("debug") && console.log('compare result =', result);

                if (error){
                    //this.props.enqueueSnackbar("Error " + result.status + " generating comparison.  " + result.message, {variant: 'error'});
                    this.handleCloseDialog();
                }

                this.setState({
                    url: result,
                    isFetching: false
                })


            })

    }


    render() {

        const classes = this.props.classes;

        return (

            <Dialog
                open={this.state.open}
                onClose={this.handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="xl"
            >
                <DialogContent>

                    <div style={{ border: 'border:1px solid #eee', height:'90vh', width:'100%'}}>
                        <div style={{height: '100%'}}>
                            {
                                this.state.isFetching ?
                                    <React.Fragment>
                                        <LinearProgress variant={"indeterminate"} color={"primary"}/>
                                        <div className={classes.progressMessage}>Preparing files for comparison...</div>
                                    </React.Fragment>
                                    :
                                    <iframe
                                        title={this.state.url}
                                        src={this.state.url}
                                        frameBorder={0}
                                        scrolling={'auto'}
                                        style={{ display:'block', width:'100%', height: '90vh'}}
                                    />
                            }
                        </div>
                    </div>

                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={this.handleCloseDialog}
                        variant="contained"
                        color="secondary">
                        {this.state.isFetching ? 'Cancel' : 'Close'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

CompareCustomDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    parentFileId: PropTypes.string.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    userDetails: PropTypes.object.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    actionConfig: PropTypes.func.isRequired
};

export default withSnackbar(withStyles(styles, { withTheme: true} )(CompareCustomDialog));